module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Rainbow-49c4b4f6c9aff266019356f06962deb1.svg";